import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteLeyendaBancaria, getLeyendasBancarias, patchLeyendaBancaria, postLeyendaBancaria,
} from 'api/recaudacion/leyendasBancarias';
import { getMetodosDePago } from 'api/configuracion';
import { getBancos } from 'api/configuracion/bancos';

const catalogs = [
  {
    permission: 'catalogodemetododepago',
    get: getMetodosDePago,
    formItemName: 'metodo_de_pago',
  },
  {
    permission: 'banco',
    get: getBancos,
    formItemName: 'banco',
  },
];

export const permissionConfig = {
  permissionModel: 'receptoresdepagos',
  catalogsModels: catalogs.map((c) => c.permission),
};

// eslint-disable-next-line react/prop-types
const LeyendasBancarias = ({ permission }) => (
  <>
    <PlainCRUD
      title="Leyenda Bancaria"
      permission={permission}
      get={getLeyendasBancarias}
      post={postLeyendaBancaria}
      patch={patchLeyendaBancaria}
      delete={deleteLeyendaBancaria}
      fields={[
        defaultFields.clave,
        {
          label: 'Identificador',
          name: 'identificador',
          colWidth: 200,
          required: true,
        },
        defaultFields.descripcion,
        {
          name: 'banco',
          label: 'Banco',
          render: (item) => item?.nombre,
          type: 'select',
        },
        {
          name: 'metodo_de_pago',
          label: 'Método de Pago',
          render: (item) => item?.concepto,
          type: 'select',
        },
        {
          label: 'Observaciones',
          name: 'observaciones',
          colWidth: 400,
          type: 'textarea',
          autoSize: { minRows: 3, maxRows: 4 },
        },
      ]}
      catalogs={catalogs}
    />
  </>
);

export default LeyendasBancarias;
